const Pill = ({ label }) => {
  return (
    <div className="badge badge-primary badge-outline mr-2">{ label }</div>
  );
};

export default Pill;
